import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import {
    CANCELED_ORDER_FAILURE,
    CANCELED_ORDER_REQUEST,
    DELETE_ORDER_FAILURE,
    DELETE_ORDER_REQUEST,
    DELIVERED_ORDER_FAILURE,
    DELIVERED_ORDER_REQUEST,
    GET_ORDERS_FAILURE,
    GET_ORDERS_REQUEST,
    GET_ORDERS_SUCCESS,
    PLACED_ORDER_FAILURE,
    PLACED_ORDER_REQUEST,
    SHIP_ORDER_FAILURE,
    SHIP_ORDER_REQUEST,
    GET_RECENT_ORDERS_FAILURE,
    GET_RECENT_ORDERS_REQUEST,
    GET_RECENT_ORDERS_SUCCESS,
    GET_INCOME_REQUEST,
    GET_INCOME_SUCCESS,
    GET_INCOME_FAILURE,
    GET_ORDER_STATS_FAILURE,
    GET_ORDER_STATS_REQUEST,
    GET_ORDER_STATS_SUCCESS,
    ADD_PENALTY_REQUEST,
    ADD_PENALTY_FAILURE,
    ASSIGN_EMPLOYEE_BY_ADMIN_REQUEST,
    ASSIGN_EMPLOYEE_BY_ADMIN_FAILURE
} from "./ActionType";

export const getOrders = () => async dispatch => {
    dispatch({ type: GET_ORDERS_REQUEST });
    try {
        const { data } = await privateAxios.get(`admin/orders`);
        dispatch({ type: GET_ORDERS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: GET_ORDERS_FAILURE, payload: error.message });
    }
};

export const getIncome = () => async dispatch => {
    dispatch({ type: GET_INCOME_REQUEST });
    try {
        const { data } = await privateAxios.get(`admin/income-overview`);
        dispatch({ type: GET_INCOME_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: GET_INCOME_FAILURE, payload: error.message });
    }
};

export const getOrderStats = () => async dispatch => {
    dispatch({ type: GET_ORDER_STATS_REQUEST });
    try {
        const { data } = await privateAxios.get(`admin/orders/stats`);
        dispatch({ type: GET_ORDER_STATS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: GET_ORDER_STATS_FAILURE, payload: error.message });
    }
};

export const getRecentOrders = () => async (dispatch) => {
    dispatch({ type: GET_RECENT_ORDERS_REQUEST })
    try {
        const { data } = await privateAxios.get(`admin/recent_orders`);
        dispatch({ type: GET_RECENT_ORDERS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_RECENT_ORDERS_FAILURE, payload: error.message })
    }
}

export const shipOrder = (orderId) => async (dispatch) => {
    dispatch({ type: SHIP_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/order/${orderId}/ship`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Shipped Successfully")
        } else {
            toast.error(data.response)
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: SHIP_ORDER_FAILURE, payload: error.message })
    }
}

export const deliveredOrder = (orderId) => async (dispatch) => {
    dispatch({ type: DELIVERED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/order/${orderId}/deliver`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Delivered Successfully")
        } else {
            toast.error(data.response)
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: DELIVERED_ORDER_FAILURE, payload: error.message })
    }
}

export const cancelOrder = (orderId) => async (dispatch) => {
    dispatch({ type: CANCELED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/order/${orderId}/cancel`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Canceled Successfully")
        } else {
            toast.error(data.response)
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: CANCELED_ORDER_FAILURE, payload: error.message })
    }
}

export const deleteOrder = (orderId) => async (dispatch) => {
    dispatch({ type: DELETE_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.delete(`admin/order/${orderId}/delete`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success(data.response)
        } else {
            toast.error(data.response)
        }

    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: DELETE_ORDER_FAILURE, payload: error.message })
    }
}

export const placeOrder = (orderId) => async (dispatch) => {
    dispatch({ type: PLACED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/order/${orderId}/place`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Confirmed and Assign Successfully")
        } else {
            toast.error(data.response)
        }

    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: PLACED_ORDER_FAILURE, payload: error.message })
    }
}

export const addPenalty = (orderId, penaltyPrice) => async (dispatch) => {
    dispatch({ type: ADD_PENALTY_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/order/${orderId}/penalty/${penaltyPrice}`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Penalty Added Successfully")
        } else {
            toast.error(data.response || "Failed to Add Penalty.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while Adding Penalty.")
        dispatch({ type: ADD_PENALTY_FAILURE, payload: error.message })
    }
}

export const assignEmployeeByAdmin = (orderId, empId, setAssignOpen, setEmpId, setOrder) => async (dispatch) => {
    dispatch({ type: ASSIGN_EMPLOYEE_BY_ADMIN_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/order/${orderId}/${empId}/assign`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            setAssignOpen(false)
            setEmpId("");
            setOrder(null)
            if (data?.response?.orderStatus === "PENDING") {
                dispatch(placeOrder(orderId))
            } else {
                toast.success("Order Assign Successfully")
            }
        } else {
            toast.error(data.response || "Failed to Assign Order.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while Assign Order.")
        dispatch({ type: ASSIGN_EMPLOYEE_BY_ADMIN_FAILURE, payload: error.message })
    }
}